var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.357 5.255H5.644C4.335 5.255 3.271 6.319 3.271 7.628V16.372C3.271 17.681 4.335 18.745 5.644 18.745H18.356C19.663 18.745 20.727 17.682 20.73 16.372V7.628C20.73 6.319 19.666 5.255 18.357 5.255ZM10.09 13.255V10.753H13.93V13.255H10.09ZM13.93 14.755V17.245H10.09V14.755H13.93ZM4.771 10.753H8.59V13.255H4.771V10.753ZM10.09 9.25301V6.755H13.93V9.25301H10.09ZM15.43 10.753H19.23L19.229 13.255H15.43V10.753ZM19.23 7.628V9.25301H15.43V6.755H18.358C18.839 6.755 19.23 7.146 19.23 7.628ZM5.644 6.755H8.59V9.25301H4.771V7.628C4.771 7.146 5.163 6.755 5.644 6.755ZM4.771 16.372V14.755H8.59V17.245H5.644C5.163 17.245 4.771 16.854 4.771 16.372ZM18.356 17.245H15.43V14.755H19.229V16.372C19.229 16.854 18.837 17.245 18.356 17.245Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.068090c742e59df4c17dc1963687e6a7.svg";
export { ForwardRef as ReactComponent };